import type { BillingFrequency } from '@proposify/pricing-engine';

export const previewMenuTestIds = {
  previewTitle: 'preview-title',
  headerDocumentName: 'header-document-name',
  headerFrequencySummary: 'header-frequency-summary',
  headerFrequency: (frequency: BillingFrequency) => `header-frequency-${frequency}`,
};
